export const projects = [
  {
    id: 1,
    name: 'AMERICAN MAGIC',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for AMERICAN MAGIC.',
    location: 'PENSACOLA, FL',
    type: 'Build',
  },
  {
    id: 2,
    name: 'SHADDIX PLASTIC SURGERY',
    image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for SHADDIX PLASTIC SURGERY.',
    location: 'PENSACOLA, FL',
    type: 'Build',
  },
  {
    id: 3,
    name: 'SPENCER LAW',
    image: 'https://images.unsplash.com/photo-1508921912186-1d1a45ebb3c1?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for SPENCER LAW.',
    location: 'PENSACOLA, FL',
    type: 'Unbuild',
  },
  {
    id: 4,
    name: 'CLARK PARTINGTON',
    image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for CLARK PARTINGTON.',
    location: 'PENSACOLA, FL',
    type: 'Unbuild',
  },
  {
    id: 5,
    name: 'BANK OF PENSACOLA',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for BANK OF PENSACOLA.',
    location: 'PENSACOLA, FL',
    type: 'Unbuild',
  },
  {
    id: 6,
    name: 'SUNSET TOWER',
    image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for SUNSET TOWER.',
    location: 'MIAMI, FL',
    type: 'Build',
  },
  {
    id: 7,
    name: 'OCEAN VIEW RESIDENCE',
    image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for OCEAN VIEW RESIDENCE.',
    location: 'TAMPA, FL',
    type: 'Build',
  },
  {
    id: 8,
    name: 'RIVERFRONT PLAZA',
    image: 'https://images.unsplash.com/photo-1508921912186-1d1a45ebb3c1?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for RIVERFRONT PLAZA.',
    location: 'JACKSONVILLE, FL',
    type: 'Build',
  },
  {
    id: 9,
    name: 'CITY CENTER',
    image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for CITY CENTER.',
    location: 'TALLAHASSEE, FL',
    type: 'Unbuild',
  },
  {
    id: 10,
    name: 'LAKE HOUSE',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80',
    description: 'Project details for LAKE HOUSE.',
    location: 'GAINESVILLE, FL',
    type: 'Build',
  },
]; 